import styled, { keyframes } from 'styled-components';
import { Text } from '~/components/ui/Text';
import casesFeedBg from '../../assets/images/cases_feed_bg.svg';

const StyledContainer = styled.div``;

const StyledEmptyContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 290px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledFeedContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 162px;
	padding: 0 0 0 40px;
	background-image: url(${casesFeedBg});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	overflow: hidden;
`;

const StyledFeedTrack = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	will-change: transform;
	transition: transform 0.35s ease;
`;

const enterFade = keyframes`
	0% { opacity: 0; }
	100% { opacity: 1; }
`;

const StyledFeedItemWrapper = styled.div`
	min-width: 180px;

	&[data-enter='true'] {
		animation: ${enterFade} 0.35s ease forwards;
	}
`;

const StyledCasesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	grid-template-rows: repeat(auto-fill, 240px);
	gap: 20px;
	height: 716px;
	padding: 20px 40px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledCasesContainer,
	StyledContainer,
	StyledEmptyContainer,
	StyledFeedContainer,
	StyledFeedItemWrapper,
	StyledFeedTrack,
};
